export const mutations = {
  addPractice(state, newPractice) {
    state.practices.push(newPractice);
  },

  setAvailableLanguages(state, languages) {
    state.availableLanguages = languages;
  },
};
